import React from 'react';
import { Grid } from '@mui/material';

interface EditFieldsButtonProps {
  numbToEdit: number;
  onClick: () => void;
}

export const EditFieldsButton: React.FC<EditFieldsButtonProps> = ({ numbToEdit, onClick }) => {
  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: '#0583FF',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        bottom: 50,
        left: '55%',
        width: 276,
        padding: '16px 24px',
        boxShadow: '0px 8px 16px rgba(20, 20, 43, 0.24)',
        height: 56,
        borderRadius: 30,
        color: 'white',
        fontFamily: 'Arial',
        fontWeight: '600',
        cursor: 'pointer'
      }}
      onClick={onClick}>
      <Grid container justifyContent="space-between" style={{ marginTop: 3 }}>
        <Grid item>
          <span>{numbToEdit} products selected</span>
        </Grid>
        <Grid item>
          <span
            style={{
              color: 'white',
              fontFamily: 'Arial',
              textDecoration: 'underline'
            }}>
            Edit
          </span>
        </Grid>
      </Grid>
    </div>
  );
};
